module.exports = __webpack_public_path__ + "static/process-detail-2a.afaa702e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/process-details/process-detail-2a.png
// module id = 1489
// module chunks = 214286880276331